export const voiceChat = $state({ open: false });
